import { render, staticRenderFns } from "./ReportsBulkPdpDownload.vue?vue&type=template&id=80b556b8&"
import script from "./ReportsBulkPdpDownload.vue?vue&type=script&lang=js&"
export * from "./ReportsBulkPdpDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports